require('./mortgageRequestAmountMortgagesExpenses.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestExpensesTrading = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestAmountMortgagesExpenses/mortgageRequestExpensesTrading/mortgageRequestExpensesTrading');
const MortgageRequestExpensesMortgage = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestAmountMortgagesExpenses/mortgageRequestExpensesMortgage/mortgageRequestExpensesMortgage');

// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @ helpers
const { formatCurrency } = require('utilities/currencyHelper');

class MortgageRequestAmountMortgagesExpenses extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isExpanded: false,
            id: 'amountmortgagesexpenses'
        };
    }

    currencyParams(param) {
        return {
            currency: param,
            symbolCurrency: 'EUR',
            periodicy: false,
            isFormated: false,
            classes: false,
            withDecimals: true
        }
    }

    render() {
        const { expensesProvision, totalGastos, isNewProperty } = this.props;
        const totalGastosFormatted = MortgageRequestCurrencyHelp(this.currencyParams(totalGastos));
        const currencyFormatted = formatCurrency('EUR');

        const rightContentTotalExpenses = (
            <div className="mortgage-request-amount-mortgages-expenses__amount">
                {totalGastosFormatted}
            </div>
        );

        return (
            <Accordion
                customClassName="mortgage-request-amount-mortgages-expenses"
                isExpanded={this.state.isExpanded}
                id={this.state.id}
            >
                <AccordionHeader name="AccordionHeader" iconStyle rightContent={rightContentTotalExpenses} isMiddleArrowPosition >
                    <div className="mortgage-request-amount-mortgages-expenses__header row no-outside-gutter">
                        <FormattedText value="mortgageRequestExpensesAmmount-tradingMortgage"></FormattedText>
                    </div>
                </AccordionHeader>

                <AccordionBody name="AccordionBody">
                    <MortgageRequestExpensesTrading
                        tradingAmmount={expensesProvision.get('gastosCompraVenta')}
                        totalGastosCompraVenta={expensesProvision.get(
                            'totalGastosCompraVenta'
                        )}
                        currencyFormatted={currencyFormatted}
                        isNewProperty={isNewProperty}
                    />

                    <MortgageRequestExpensesMortgage
                        mortgageAmmount={expensesProvision.get('gastosHipoteca')}
                        totalGastosHipoteca={expensesProvision.get('totalGastosHipoteca')}
                        currencyFormatted={currencyFormatted}
                    />
                </AccordionBody>
            </Accordion>
        );
    }
}

MortgageRequestAmountMortgagesExpenses.propTypes = {
    expensesProvision: PropTypes.object,
    totalGastos: PropTypes.number.isRequired,
    isNewProperty: PropTypes.bool
};

MortgageRequestAmountMortgagesExpenses.defaultProps = {
    totalGastos: 0
};

module.exports = MortgageRequestAmountMortgagesExpenses;
